import React from 'react';

export default function WeaponsmithHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="37.56,35.53 10.54,35.53 10.54,8.52 37.56,8.52" fill="#392F28" />
      <polygon points="10.54,35.53 37.56,35.53 29.46,31.48 2.44,31.48" fill="#000000" opacity="0.95" />
      <polygon points="10.54,35.53 2.44,31.48 2.44,4.47 10.54,8.52" fill="#000000" opacity="0.95" />
      <polygon points="38.0,35.92 10.31,35.92 10.31,8.23 38.0,8.23" fill="#392F28" />
      <polygon points="10.31,35.92 38.0,35.92 29.69,31.77 2.0,31.77" fill="#000000" opacity="0.95" />
      <polygon points="10.31,35.92 2.0,31.77 2.0,4.08 10.31,8.23" fill="#000000" opacity="0.95" />
    </svg>
  );
}
